<template>
  <b-card
    title="مدیریت کارکردها"
  >
    <b-row>
      <b-col
        class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <!--              <b-button-->
              <!--                class="mb-1 mr-auto ml-1"-->
              <!--                variant="primary"-->
              <!--                @click="addOrder()"-->
              <!--              >-->
              <!--                جدید-->
              <!--              </b-button>-->

              <b-col md="2">
                <b-form-group
                  label="عنوان"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="کاربر"
                  label-for="UserId"
                >
                  <z-user
                    v-model="filterOptions.UserId"
                    :clearable="true"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="درمانگاه"
                  label-for="ClinicId"
                >
                  <z-clinic
                    v-model="filterOptions.ClinicId"
                    :clearable="true"
                  />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group
                  label="فرآیند"
                  label-for="OrderCategoryProcessId"
                >
                  <z-order-category-process
                    v-model="filterOptions.OrderCategoryProcessId"
                    :clearable="true"
                  />
                </b-form-group>
              </b-col>

              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
          :no-local-sorting="true"
          :sort-by="filterOptions.SortBy"
          :sort-desc="filterOptions.IsDesc"
          @sort-changed="sortChange"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              @click="updateOrder(data.item)"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(User)="data">
            <b-badge
              variant="info"
            >
              {{ data.value.Name }} {{ data.value.Family }}
            </b-badge>
          </template>

          <template #cell(OrderCategoryProcess)="data">
            <b-badge
              variant="success"
            >
              {{ data.value.Title }}
            </b-badge>
            <b-badge variant="light-secondary" style="margin-top: 5px;">
              {{ data.item.Order.OrderCategory.Title }}
            </b-badge>
          </template>

          <template #cell(Date)="data">
            {{ data.value | date }}
          </template>

          <template #cell(OrderTooth)="data">
            {{ data.item.Order.OrderTooth.length }} واحد
          </template>

          <template #cell(Clinic)="data">
            {{ data.item.Order.Clinic.Title }}
          </template>

          <template #cell(Patient)="data">
            {{ data.item.Order.Patient }}
          </template>

          <template #cell(CreatedAt)="data">
            {{ data.value | date }}
          </template>

          <template #cell(OrderDate)="data">
            {{ data.item.Order.Date | date }}
          </template>

          <template #cell(OrderCategory)="data">
            {{ data.item.Order.OrderCategory.Title }}
          </template>

          <template #cell(Price)="data">
            <template v-if="data.value != null">
              {{ data.value | price }}
            </template>
          </template>

          <template #cell(TotalPrice)="data">
            <template v-if="data.item.Price != null">
              {{ (data.item.Price * data.item.Order.OrderTooth.length) | price }}
            </template>
          </template>

          <template #cell(actions)="data">

            <div
              class="action-color"
            >

              <b-link
                :href="'https://24dentallab.ir/label/'+data.item.Id"
                target="_blank"
              >
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="PrinterIcon"
                  size="16"
                />
              </b-link>

              <feather-icon
                icon="LoaderIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="showProcess(data.item)"
              />

              <b-link @click="updateOrder(data.item)">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                  class="mt-1"
                />
              </b-link>

              <feather-icon
                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer mt-1"
                @click="remove(data.item.Id)"
              />

            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>

  </b-card>
</template>

<script>

import ZClinic from '@/tools/clinic.vue'
import ZColor from '@/tools/color.vue'
import ZOrderCategory from '@/tools/ordercategory.vue'
import ZOrderCategoryProcess from '@/tools/ordercategoryprocess.vue'
import ZUser from '@/tools/user.vue'

export default {
  name: 'Order',
  components: {
    ZUser,
    ZOrderCategoryProcess,
    ZOrderCategory,
    ZClinic,
    ZColor,
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        ClinicId: null,
        Page: 1,
        OrderCategoryProcessId: null,
        Title: null,
        SortBy: 'Id',
        IsDesc: true,
        UserId: null,
      },
      showOrderModal: false,
      showProcessModal: false,
      row: {},
      // teeth: this.generateTeeth(),
      selectedTeeth: [],
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          sortable: true,
          thClass: 'col-width-50',
        },
        {
          key: 'User',
          label: 'کاربر',
        },
        {
          key: 'CreatedAt',
          label: 'تاریخ',
        },
        {
          key: 'OrderCategoryProcess',
          label: 'فرآیند',
        },
        // {
        //   key: 'OrderCategory',
        //   label: 'دسته بندی',
        // },
        {
          key: 'OrderDate',
          label: 'تاریخ سفارش',
        },
        {
          key: 'Patient',
          label: 'بیمار',
        },
        {
          key: 'Clinic',
          label: 'درمانگاه',
        },
        {
          key: 'OrderTooth',
          label: 'تعداد',
        },
        {
          key: 'Price',
          label: 'مبلغ',
        },
        {
          key: 'TotalPrice',
          label: 'مبلغ کل',
        },
        // {
        //   key: 'actions',
        //   label: '',
        //   thClass: 'col-width-89',
        // },
      ],
      items: [],
    }
  },
  computed: {},
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.userordercategoryprocess.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      let url = this.$api.order.add
      if (this.row.Id) {
        url = this.$api.order.update
      }

      const formData = new FormData()

      formData.append('Id', this.row.Id)

      if (this.row.Description) {
        formData.append('Description', this.row.Description)
      }

      // formData.append('Image', this.row.Image)

      if (this.row.ClinicId) {
        formData.append('ClinicId', this.row.ClinicId)
      }

      if (this.row.OrderCategoryId) {
        formData.append('OrderCategoryId', this.row.OrderCategoryId)
      }

      if (this.row.ColorId) {
        formData.append('ColorId', this.row.ColorId)
      }

      if (this.row.Date) {
        formData.append('Date', this.row.Date)
      }

      formData.append('IncludeInInvoice', this.row.IncludeInInvoice)

      if (this.row.Patient) {
        formData.append('Patient', this.row.Patient)
      }

      if (this.row.TrackingCode) {
        formData.append('TrackingCode', this.row.TrackingCode)
      }

      this.row.OrderTooth.forEach((item, index) => {
        formData.append(`OrderTooth[${index}]`, item)
      })

      if (this.row.Price) {
        formData.append('Price', this.row.Price.replaceAll(',', ''))
      }

      const image = this.$refs.refGalley1.files[0]

      if (image) {
        formData.append('Image', image)
      }

      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.update()
        })
        .catch(() => {
          this.showOrderModal = true
        })
    },
    addOrder() {
      this.row = {
        ClinicId: null, ColorId: null, IncludeInInvoice: true, TrackingCode: null, Date: this.today(), Description: null, OrderCategoryId: null, Discount: null, Patient: null, Image: null, OrderTooth: [],
      }

      this.showOrderModal = true
    },
    updateOrder(row) {
      this.row = {
        Id: row.Id,
        ClinicId: row.Clinic.Id,
        Date: row.Date,
        Description: row.Description,
        OrderCategoryId: row.OrderCategory.Id,
        ColorId: row.Color?.Id,
        Price: row.Price,
        Patient: row.Patient,
        Image: row.Image,
        OrderTooth: row.OrderTooth,
        TrackingCode: row.TrackingCode,
        IncludeInInvoice: row.IncludeInInvoice,
      }

      this.showOrderModal = true
    },
    showProcess(row) {
      this.row = row
      this.showProcessModal = true
    },
    remove(id) {
      this.removeRow(this.$api.order.remove, 'Id', id)
    },
    today() {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    // generateTeeth() {
    //   const teeth = []
    //   for (let i = 1; i <= 32; i++) {
    //     teeth.push({ id: i })
    //   }
    //   return teeth
    // },
    toggleTooth(toothId) {
      const index = this.row.OrderTooth.indexOf(toothId)

      if (index === -1) {
        this.row.OrderTooth.push(toothId)
      } else {
        this.row.OrderTooth.splice(index, 1)
      }
    },
    isSelected(toothId) {
      return this.row.OrderTooth.includes(toothId)
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.row.Image = fileReader.result
      }
    },
  },
}
</script>

<style>
.teeth-grid {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 0.25rem;
  margin: 0px auto;
  margin-bottom: 1rem;
  padding: 0px 1rem;
  justify-content: center;
}

.tooth {
  width: calc((100% - 4.5rem) / 16);
  height: 25px;
  cursor: pointer;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: normal;
  margin-top: 0.5rem;

}

.tooth.selected {
  box-shadow: 0 2px 4px 0 rgba(0, 207, 232, 0.4) !important;
  border-color: #00cfe8;
  background-color: #00cfe8;
  color: #fff;
}

.teeth-grid div:nth-child(8),
.teeth-grid div:nth-child(24) {
  margin-right: 0.75rem;
}

.order-upload {
  align-items: center;
  display: flex;
  height: 112px;
  justify-content: center;
  margin: 0;
  width: 112px;
  text-align: center;
  border: 1px solid #dbdade;
  cursor: pointer;
  border-radius: 0.357rem;
  flex-direction: column;
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .responsive-upload{
    width: 100%; display: flex;
  }
}

.order-upload img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.357rem;
}

.col-width-89{
  width: 89px;
}

.action-color a {
  color: #6e6b7b !important;
}
</style>
